import { render, staticRenderFns } from "./EventGuide.vue?vue&type=template&id=4c80e25a&scoped=true&"
import script from "./EventGuide.vue?vue&type=script&lang=js&"
export * from "./EventGuide.vue?vue&type=script&lang=js&"
import style0 from "./EventGuide.vue?vue&type=style&index=0&id=4c80e25a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c80e25a",
  null
  
)

export default component.exports